import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { ErrorHandlingService } from '../../../../../core/services/error-handling.service';
import {
  ApiResponse,
  BehaviorDetailModel,
  BehaviorModel,
  BehaviorValidationStatus,
} from '../../../insights.interface';

@Injectable({
  providedIn: 'root',
})
export class BehaviorService {
  private readonly API_URL = `${environment.apiUrl}`;

  constructor(
    private errorHandler: ErrorHandlingService,
    private http: HttpClient
  ) {}

  createBehavior(
    payload: BehaviorModel
  ): Observable<ApiResponse<BehaviorModel>> {
    return this.http
      .post<
        ApiResponse<BehaviorModel>
      >(`${this.API_URL}/behavior/create`, payload)
      .pipe(
        tap(res => {
          return res;
        }),
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  editBehavior(
    payload: BehaviorModel,
    behaviorId: number
  ): Observable<ApiResponse<BehaviorModel>> {
    return this.http
      .put<
        ApiResponse<BehaviorModel>
      >(`${this.API_URL}/behavior/update?caseBehaviorMappingId=${behaviorId}`, payload)
      .pipe(
        tap(res => {
          return res;
        }),
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  getBehaviorById(id: number) {
    return this.http
      .get<ApiResponse<BehaviorDetailModel>>(`${this.API_URL}/behavior/${id}`)
      .pipe(
        tap((response: ApiResponse<BehaviorDetailModel>) => response),
        catchError(error => this.errorHandler.handleError(error))
      );
  }

  deleteBehavior(id: number) {
    return this.http
      .delete<ApiResponse<void>>(`${this.API_URL}/behavior/${id}`, {})
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  getBehaviorValidationStatus(
    behaviorId: number
  ): Observable<ApiResponse<BehaviorValidationStatus>> {
    return this.http
      .get<
        ApiResponse<BehaviorValidationStatus>
      >(`${this.API_URL}/behavior/get-pending-items?caseBehaviorMappingId=${behaviorId}`)
      .pipe(catchError(error => this.errorHandler.handleError(error)));
  }

  updateBehaviorStatus(behaviorId: number, statusId: number) {
    return this.http
      .patch<
        ApiResponse<string>
      >(`${this.API_URL}/behavior/update-status?caseBehaviorMappingId=${behaviorId}&statusId=${statusId}`, '')
      .pipe(
        tap(res => {
          return res;
        }),
        catchError(error => this.errorHandler.handleError(error))
      );
  }
}
